import { createMemoryRouter } from 'react-router';

import { AppShell } from '@/app-shell';
import { routes } from '@/routes';

/**
 * Build-time entry for vite-prerender-plugin (see vite.config.ts). Runs in
 * Node, so it must never touch window/document. Uses the Web Streams SSR API
 * because the prerender chunk is bundled with browser resolution, which stubs
 * out Node built-ins like node:stream.
 */
export async function prerender(data: { url: string }) {
  const { renderToReadableStream } = await import('react-dom/server');

  const router = createMemoryRouter(routes, { initialEntries: [data.url] });

  const stream = await renderToReadableStream(<AppShell router={router} />, {
    onError(error) {
      console.error(`prerender: error rendering ${data.url}`, error);
    },
  });

  // Wait for Suspense boundaries (lazy route chunks) to fully resolve.
  await stream.allReady;
  const html = await new Response(stream as unknown as BodyInit).text();

  return { html };
}
